import { ErrorHandler, NgZone } from "@angular/core";
import { Injectable } from "@angular/core";
import { SharedService } from "./service";

@Injectable()
export class CustomErrorHandler implements ErrorHandler {


  constructor(private shared: SharedService, private zone: NgZone) {

  }

  async handleError(error: any) {

    console.error(error);

    try {
      let summary: string;
      let detail: string;

      if (error instanceof Error) {
        const { name, message, stack } = error;
        const path = location.pathname;
        const code = await this.shared.logError(JSON.stringify({ path, name, message, stack })).toPromise();
        if (code != null) {
          summary = this.shared.res['#Unexpected error'];
          detail = this.shared.res['#Error code: {{code}}']({ code: code.toString() });
        } else {
          summary = this.shared.res['#Unexpected error'];
          detail = this.shared.res['#Error message: {{message}}']({ message });
        }
      } else {
        summary = this.shared.res['#Unexpected error'];
        detail = this.shared.res['#Error: {{error}}']({ error: error.toString() });
      }

      alert(summary + '\n' + detail);

      } catch (error) { }
  }
}
